import React from 'react';
import { IOldIconProps } from './type';

const Expand: React.FC<IOldIconProps> = ({
  width,
  height,
  color = '#000',
  ...props
}) => {
  return (
    <svg
      width={width || 32}
      height={height || 32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 13l6 6 6-6"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Expand;
